import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '@/ui/store/store';
import { setLanguage } from '@/ui/store/slices/languageSlice';


export const useLanguage = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const language = useSelector((state: RootState) => state.language.language);

  useEffect(() => {
    if (i18n.isInitialized) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);
  

  const changeLanguage = (lang: string) => {
    dispatch(setLanguage(lang));
  };

  return { language, changeLanguage };
};
